enum DeductibleStatus {
  CarrotSpecificDeductible = "CarrotSpecificDeductible",
  ExternalDeductible = "ExternalDeductible",
  NoDeductible = "NoDeductible"
}

export { DeductibleStatus }
